import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H2 } from 'components/common/Text/Text'
import Link from 'components/common/Link/Link'
import Icon from 'components/common/Icon/Icon'
import PromotionSpotlightStyles from 'components/common/PromotionSpotlight/PromotionSpotlightStyles'
import { LazyDiv } from 'components/common/LazyHtml'

const BOTFeaturedDeals = ({
  title,
  items,
  link: [{
    displayName,
    link: { path } = {}
  } = {}] = [],
  handlePromotionClick
}) =>
  Boolean(items && items.length) &&
  <Wrapper data-at-services-featureddeals>
    <Title link headline narrow centered>{ title }</Title>
    { path &&
      <View data-at-services-featureddeals-viewall bolder to={ path } >
        { displayName }
        <Icon asset="arrow-blue-right" margin="-2px 0 0 4px" alt="" />
      </View>
    }
    <FeaturedSection>
      {
        items.map(({ data, ...item } = {}, index) =>
          <FeaturedBlockWrapper
            data-at-services-featureddeals-deal
            key={ index }
            content={ data }
            onClick={ event => handlePromotionClick({ event, item, index }) } />)
      }
    </FeaturedSection>
  </Wrapper>

BOTFeaturedDeals.propTypes = {
  handlePromotionClick: PropTypes.func,
  items: PropTypes.arrayOf(PropTypes.shape({ data: PropTypes.shape })),
  link: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

export default BOTFeaturedDeals

const Wrapper = styled.div`
  position: relative;
  text-align: center;
  ${Mixin.responsive('padding', '60px 0 10px', '40px 8px 16px')}
  ${Mixin.clearFix()}
`

const Title = styled(H2)`
  ${Media.mobile`
    font-size: 20px;
    line-height: 30px;
  `}
  ${Mixin.responsive('margin', '0 0 32px', '0 0 30px')}
  ${props => props.link && css`
    ${Media.mobile`
      margin-bottom: 7px;
    `}
  `}
`

const View = styled(Link)`
  display: inline-block;
  ${Media.desktop`
    position: absolute;
    top: 75px;
    right: 0;
  `}
  ${Media.mobile`
    margin-bottom: 30px;
  `}
`

const FeaturedSection = styled.div`
  margin: 0 -12px;
  text-align: center;
`

const FeaturedBlockWrapper = styled(LazyDiv)`
  display: inline-block;
  padding: 0 12px 24px;
  text-align: left;
  ${PromotionSpotlightStyles}
`
